import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import FormSF from '../../../widgets/form/FormSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const AlertRuleCreateOrUpdateUI = ({context, messageList, projectType,
  // priority
  priority, priorityList, onPriorityChange, priorityError,
  // dueInDays
  dueInDays, dueInDaysList, onDueInDaysChange, dueInDaysError,
  // duePastDays
  duePastDays, duePastDaysList, onDuePastDaysChange, duePastDaysError,
  // repeatIntervalDays
  repeatIntervalDays, repeatIntervalDaysList, onRepeatIntervalDaysChange, repeatIntervalDaysError,
  // form
  onSubmit, submitted, successMsg, errorList, setErrorList, onCancelCreateClick
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_save'
      successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      onSubmit={onSubmit} onCancel={onCancelCreateClick} busy={submitted}>
      <InputSelectUI name='priority' value={priority} required={true}
        messageList={messageList} labelKey='c_task_priority'
        optionList={priorityList}
        onChange={onPriorityChange} error={priorityError}
      />
      <InputSelectUI name='dueInDays' value={dueInDays} required={true}
        messageList={messageList} labelKey='c_task_due_in'
        optionList={dueInDaysList}
        onChange={onDueInDaysChange} error={dueInDaysError}
      />
      <InputSelectUI name='repeatIntervalDays' value={repeatIntervalDays} required={true}
        messageList={messageList} labelKey='c_repeat'
        optionList={repeatIntervalDaysList}
        onChange={onRepeatIntervalDaysChange} error={repeatIntervalDaysError}
      />
      {
        repeatIntervalDays !== 'd0' &&
        <InputSelectUI name='duePastDays' value={duePastDays} required={true}
          messageList={messageList} labelKey='c_task_due_past'
          optionList={duePastDaysList}
          onChange={onDuePastDaysChange} error={duePastDaysError}
        />
      }
    </FormSF>
  </CardUI>


export default AlertRuleCreateOrUpdateUI
